import values from 'lodash/values'

import type { RouteDef } from '@ztechapps/common.contract'

export const routesDef = {
  OverviewPage: {
    name: 'Overview',
    path: '/app/overview',
    exact: true,
    layout: 'main',
  },

  TicketListPage: {
    name: 'Tickets',
    path: '/app/tickets/list',
    exact: true,
    layout: 'main',
  },
  TicketDetailPage: {
    name: 'Ticket Detail',
    path: '/app/tickets/detail/:_id',
    altPath: ({ _id }: { _id: string }) => {
      _id = encodeURIComponent(_id)
      return `/app/tickets/detail/${_id}`
    },
    exact: true,
    layout: 'main',
  },
  TicketManifestPage: {
    name: 'Manifest',
    path: '/app/tickets/manifest/:_id',
    altPath: ({ _id }: { _id: string }) => {
      _id = encodeURIComponent(_id)
      return `/app/tickets/manifest/${_id}`
    },
    exact: true,
    layout: 'main',
  },

  DriverListPage: {
    name: 'Drivers',
    path: '/app/drivers/list',
    exact: true,
    layout: 'main',
  },
  DriverDetailPage: {
    name: 'Driver Detail',
    path: '/app/drivers/detail/:_id',
    altPath: ({ _id }: { _id: string }) => {
      _id = encodeURIComponent(_id)
      return `/app/drivers/detail/${_id}`
    },
    exact: true,
    layout: 'main',
  },

  RouteListPage: {
    name: 'Routes',
    path: '/app/routes/list',
    exact: true,
    layout: 'main',
  },
  RouteDetailPage: {
    name: 'Route Detail',
    path: '/app/routes/detail/:_id',
    altPath: ({ _id }: { _id: string }) => {
      _id = encodeURIComponent(_id)
      return `/app/routes/detail/${_id}`
    },
    exact: true,
    layout: 'main',
  },

  CustomerListPage: {
    name: 'Customers',
    path: '/app/customers/list',
    exact: true,
    layout: 'main',
  },
  CustomerDetailPage: {
    name: 'Customer Detail',
    path: '/app/customers/detail/:_id',
    altPath: ({ _id }: { _id: string }) => {
      _id = encodeURIComponent(_id)
      return `/app/customers/detail/${_id}`
    },
    exact: true,
    layout: 'main',
  },

  SettingsPage: {
    name: 'Settings',
    path: '/app/settings',
    exact: true,
    layout: 'main',
  },

  JoinPage: {
    name: 'Join',
    path: '/account/join',
    altPath: () => '/account/join',
    exact: true,
    layout: 'blank',
  },

  AuthSuccessPage: {
    name: 'Auth Success',
    path: '/auth/success/:auth',
    exact: true,
    layout: 'blank',
  },
  AuthFailedPage: {
    name: 'Auth Failed',
    path: '/auth/failed',
    exact: true,
    layout: 'blank',
  },

  LoginPage: {
    name: 'Login',
    path: '/account/login',
    altPath: () => '/account/login',
    exact: true,
    layout: 'blank',
  },
  LoadingPage: {
    name: 'Loading',
    path: '/',
    exact: true,
    layout: 'blank',
  },
  ChangePasswordPage: {
    name: 'Change Password',
    path: '/account/change-password/:username?/:code?',
    altPath: () => '/account/change-password',
    exact: true,
    layout: 'blank',
  },
} as const satisfies Record<string, RouteDef>

export const routesArray = values(routesDef)
